// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from '@hey-api/client-fetch'
import type {
  ChangeSpecialOfferStatusData,
  ChangeSpecialOfferStatusResponse,
  ChangeSpecialOfferStatusError,
  ChangeAccountAssignmentFileStatusData,
  ChangeAccountAssignmentFileStatusResponse,
  ChangeAccountAssignmentFileStatusError,
  DeleteSpecialOfferData,
  DeleteSpecialOfferResponse,
  DeleteSpecialOfferError,
  GetSpecialOfferData,
  GetSpecialOfferResponse,
  GetSpecialOfferError,
  UpdateSpecialOfferData,
  UpdateSpecialOfferResponse,
  UpdateSpecialOfferError,
  DeleteSegmentedStoreData,
  DeleteSegmentedStoreResponse,
  DeleteSegmentedStoreError,
  GetSegmentedStoreData,
  GetSegmentedStoreResponse,
  GetSegmentedStoreError,
  UpdateSegmentedStoreData,
  UpdateSegmentedStoreResponse,
  UpdateSegmentedStoreError,
  ChangeSegmentedStoreStatusData,
  ChangeSegmentedStoreStatusResponse,
  ChangeSegmentedStoreStatusError,
  MarkSegmentedStoreAsDefaultData,
  MarkSegmentedStoreAsDefaultResponse,
  MarkSegmentedStoreAsDefaultError,
  CreateSpecialOfferPurchaseData,
  CreateSpecialOfferPurchaseResponse,
  CreateSpecialOfferPurchaseError,
  CreatePurchaseData,
  CreatePurchaseResponse,
  CreatePurchaseError,
  CallbackData,
  CallbackResponse,
  CallbackError,
  GetSpecialOfferItemsData,
  GetSpecialOfferItemsResponse,
  GetSpecialOfferItemsError,
  AddSpecialOfferItemData,
  AddSpecialOfferItemResponse,
  AddSpecialOfferItemError,
  UpsertAssignmentsData,
  UpsertAssignmentsResponse,
  UpsertAssignmentsError,
  GetAccountAssignmentFilesProcessingHistoryData,
  GetAccountAssignmentFilesProcessingHistoryResponse,
  GetAccountAssignmentFilesProcessingHistoryError,
  AssignAccountsFileUploadData,
  AssignAccountsFileUploadResponse,
  AssignAccountsFileUploadError,
  GetSpecialOfferViewData,
  GetSpecialOfferViewResponse,
  GetSpecialOfferViewError,
  AddSpecialOfferData,
  AddSpecialOfferResponse,
  AddSpecialOfferError,
  GetSegmentedStoresListViewData,
  GetSegmentedStoresListViewResponse,
  GetSegmentedStoresListViewError,
  AddSegmentedStoreData,
  AddSegmentedStoreResponse,
  AddSegmentedStoreError,
  GetStoreItemsData,
  GetStoreItemsResponse,
  GetStoreItemsError,
  AddStoreItemData,
  AddStoreItemResponse,
  AddStoreItemError,
  GetConfigData,
  GetConfigResponse,
  GetConfigError,
  UpdateConfigData,
  UpdateConfigResponse,
  UpdateConfigError,
  GetPurchaseData,
  GetPurchaseResponse,
  GetPurchaseError,
  OffersData,
  OffersResponse2,
  OffersError,
  DeleteSpecialOfferItemData,
  DeleteSpecialOfferItemResponse,
  DeleteSpecialOfferItemError,
  GetSpecialOfferItemData,
  GetSpecialOfferItemResponse,
  GetSpecialOfferItemError,
  DeleteStoreItemData,
  DeleteStoreItemResponse,
  DeleteStoreItemError,
  GetStoreItemData,
  GetStoreItemResponse,
  GetStoreItemError,
  GetDefaultImagesData,
  GetDefaultImagesResponse,
  GetDefaultImagesError,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Change Special Offer status
 */
export const changeSpecialOfferStatus = <ThrowOnError extends boolean = false>(
  options: Options<ChangeSpecialOfferStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ChangeSpecialOfferStatusResponse,
    ChangeSpecialOfferStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Change Account Assignment File Status
 */
export const changeAccountAssignmentFileStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChangeAccountAssignmentFileStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ChangeAccountAssignmentFileStatusResponse,
    ChangeAccountAssignmentFileStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/account-assignment-uploads/{fileId}/status',
    ...options,
  })
}

/**
 * Delete Special Offer
 */
export const deleteSpecialOffer = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSpecialOfferData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSpecialOfferResponse,
    DeleteSpecialOfferError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}',
    ...options,
  })
}

/**
 * Get Special Offer
 */
export const getSpecialOffer = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialOfferData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpecialOfferResponse,
    GetSpecialOfferError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}',
    ...options,
  })
}

/**
 * Update Special Offer
 */
export const updateSpecialOffer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSpecialOfferData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSpecialOfferResponse,
    UpdateSpecialOfferError,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  })
}

/**
 * Delete a Segmented Store
 */
export const deleteSegmentedStore = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSegmentedStoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSegmentedStoreResponse,
    DeleteSegmentedStoreError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}',
    ...options,
  })
}

/**
 * Get a Segmented Store
 */
export const getSegmentedStore = <ThrowOnError extends boolean = false>(
  options: Options<GetSegmentedStoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSegmentedStoreResponse,
    GetSegmentedStoreError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}',
    ...options,
  })
}

/**
 * Update a Segmented Store
 */
export const updateSegmentedStore = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSegmentedStoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSegmentedStoreResponse,
    UpdateSegmentedStoreError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Change Segmented Store status
 */
export const changeSegmentedStoreStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ChangeSegmentedStoreStatusData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    ChangeSegmentedStoreStatusResponse,
    ChangeSegmentedStoreStatusError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Mark Segmented Store as default
 */
export const markSegmentedStoreAsDefault = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkSegmentedStoreAsDefaultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    MarkSegmentedStoreAsDefaultResponse,
    MarkSegmentedStoreAsDefaultError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/default',
    ...options,
  })
}

/**
 * Purchase an special offer item from the store
 */
export const createSpecialOfferPurchase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateSpecialOfferPurchaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSpecialOfferPurchaseResponse,
    CreateSpecialOfferPurchaseError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/purchases/special-store-item',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Purchase an regular item from the store
 */
export const createPurchase = <ThrowOnError extends boolean = false>(
  options: Options<CreatePurchaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePurchaseResponse,
    CreatePurchaseError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/purchases/regular-store-item',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Receive payment notification
 */
export const callback = <ThrowOnError extends boolean = false>(
  options: Options<CallbackData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CallbackResponse,
    CallbackError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/payments/pay-webhooks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get all Special Offer Items
 */
export const getSpecialOfferItems = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialOfferItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpecialOfferItemsResponse,
    GetSpecialOfferItemsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/items',
    ...options,
  })
}

/**
 * Create a Special Offer Item
 */
export const addSpecialOfferItem = <ThrowOnError extends boolean = false>(
  options: Options<AddSpecialOfferItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddSpecialOfferItemResponse,
    AddSpecialOfferItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Upserts Special Offers Assignments
 */
export const upsertAssignments = <ThrowOnError extends boolean = false>(
  options: Options<UpsertAssignmentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UpsertAssignmentsResponse,
    UpsertAssignmentsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Account Assignment Files history that started or completed processing
 */
export const getAccountAssignmentFilesProcessingHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAccountAssignmentFilesProcessingHistoryData,
    ThrowOnError
  >,
) => {
  return (options.client ?? _heyApiClient).get<
    GetAccountAssignmentFilesProcessingHistoryResponse,
    GetAccountAssignmentFilesProcessingHistoryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/account-assignment-uploads',
    ...options,
  })
}

/**
 * Upload Account Assignment File
 */
export const assignAccountsFileUpload = <ThrowOnError extends boolean = false>(
  options: Options<AssignAccountsFileUploadData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AssignAccountsFileUploadResponse,
    AssignAccountsFileUploadError,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/account-assignment-uploads',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  })
}

/**
 * Get the Special Offer view
 */
export const getSpecialOfferView = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialOfferViewData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpecialOfferViewResponse,
    GetSpecialOfferViewError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers',
    ...options,
  })
}

/**
 * Create a special offer in DRAFT state
 */
export const addSpecialOffer = <ThrowOnError extends boolean = false>(
  options: Options<AddSpecialOfferData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddSpecialOfferResponse,
    AddSpecialOfferError,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  })
}

/**
 * Get the Segmented Store list view
 */
export const getSegmentedStoresListView = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSegmentedStoresListViewData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSegmentedStoresListViewResponse,
    GetSegmentedStoresListViewError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores',
    ...options,
  })
}

/**
 * Create a Segmented Store
 */
export const addSegmentedStore = <ThrowOnError extends boolean = false>(
  options: Options<AddSegmentedStoreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddSegmentedStoreResponse,
    AddSegmentedStoreError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get all Regular Store Items for given Segmented Store
 */
export const getStoreItems = <ThrowOnError extends boolean = false>(
  options: Options<GetStoreItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetStoreItemsResponse,
    GetStoreItemsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/items',
    ...options,
  })
}

/**
 * Create a Regular Store Item
 */
export const addStoreItem = <ThrowOnError extends boolean = false>(
  options: Options<AddStoreItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddStoreItemResponse,
    AddStoreItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get First Purchase Offers Configuration for given brand
 */
export const getConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetConfigResponse,
    GetConfigError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/first-purchase-configuration',
    ...options,
  })
}

/**
 * Updates First Purchase Offers Configuration
 */
export const updateConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateConfigResponse,
    UpdateConfigError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/first-purchase-configuration',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Returns purchase for given purchase id
 */
export const getPurchase = <ThrowOnError extends boolean = false>(
  options: Options<GetPurchaseData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetPurchaseResponse,
    GetPurchaseError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/purchases/{purchaseId}',
    ...options,
  })
}

/**
 * Returns items from the store assigned to the player based on Segment assigned
 */
export const offers = <ThrowOnError extends boolean = false>(
  options?: Options<OffersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    OffersResponse2,
    OffersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/offers',
    ...options,
  })
}

/**
 * Delete a Special Offer Item
 */
export const deleteSpecialOfferItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSpecialOfferItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSpecialOfferItemResponse,
    DeleteSpecialOfferItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/items/{itemId}',
    ...options,
  })
}

/**
 * Get a Special Offer Item
 */
export const getSpecialOfferItem = <ThrowOnError extends boolean = false>(
  options: Options<GetSpecialOfferItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSpecialOfferItemResponse,
    GetSpecialOfferItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/special-offers/{specialOfferId}/items/{itemId}',
    ...options,
  })
}

/**
 * Delete a Regular Store Item
 */
export const deleteStoreItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStoreItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteStoreItemResponse,
    DeleteStoreItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/items/{itemId}',
    ...options,
  })
}

/**
 * Get a Regular Store Item
 */
export const getStoreItem = <ThrowOnError extends boolean = false>(
  options: Options<GetStoreItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetStoreItemResponse,
    GetStoreItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/segmented-stores/{segmentedStoreId}/items/{itemId}',
    ...options,
  })
}

/**
 * Get all default images for offer
 */
export const getDefaultImages = <ThrowOnError extends boolean = false>(
  options: Options<GetDefaultImagesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetDefaultImagesResponse,
    GetDefaultImagesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/inventory/brands/{brandId}/images',
    ...options,
  })
}
